import React from 'react';
import { compareDate } from '../comparators/compareDate';
export const DateFilter: React.ComponentType<{
  onChange: (values: string[]) => void;
  value?: string[];
}> = ({ onChange, value = [] }) => {
  return (
    <>

    </>
  );
};

function listWithoutDateIfPresent(list: string[], date: string) {
  const index = list.findIndex(
    (item) => compareDate(new Date(item), new Date(date)) === 0
  );
  if (index > -1) {
    return [...list.slice(0, index), ...list.slice(index + 1)];
  }
  return undefined;
}
